var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPolygon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.67 19.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.54,.52c-.31,.18-.52,.51-.55,.87l-.1,.97c.27,.39,.72,.65,1.23,.65,.83,0,1.5-.67,1.5-1.5,0-.24-.06-.47-.17-.67l-.89-.38c-.33-.14-.71-.12-1.03,.07Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.12,
    cy: 1.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.13,6.83l-.14-.96c-.06-.4-.32-.73-.68-.89l-.89-.38c-.61,.19-1.06,.75-1.06,1.43,0,.24,.06,.47,.17,.67l.3,.13,.05,.32c.26,.23,.61,.38,.99,.38,.54,0,1-.28,1.27-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.61,6.03c0-.74,.36-1.39,.92-1.8L5.34,1.2c.01,.1,.03,.2,.03,.3,0,.74-.36,1.39-.92,1.8l7.18,3.03c-.01-.1-.03-.2-.03-.3Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.86,
    cy: 6.03,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3,14.83l-.14-.96c-.26-.23-.61-.38-.99-.38-.83,0-1.5,.67-1.5,1.5,0,.57,.32,1.06,.79,1.31l.94-.19c.59-.12,.98-.68,.9-1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.17,12.74c.3,0,.59,.06,.85,.17l-.75-5.14c-.39,.31-.87,.51-1.41,.51-.3,0-.59-.06-.85-.17l.75,5.13c.39-.31,.87-.51,1.41-.51Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.17,
    cy: 14.99,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 17.81,
    r: 1.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.16,16.3c.36,.4,.59,.92,.59,1.51,0,.26-.05,.5-.13,.73l9.89-2.04c-.36-.4-.59-.92-.59-1.51,0-.26,.05-.5,.13-.73l-9.89,2.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5,16.31c-.4,0-.77,.16-1.04,.42l-.1,.97c-.04,.36,.1,.72,.37,.96,.21,.19,.48,.29,.76,.29,.08,0,.15,0,.23-.02l.95-.19c.2-.26,.33-.57,.33-.92,0-.83-.67-1.5-1.5-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5,15.56c.5,0,.95,.17,1.33,.44L4.07,3.54c-.29,.13-.61,.21-.94,.21-.5,0-.95-.17-1.33-.44L.56,15.77c.29-.13,.61-.21,.94-.21Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/polygon.8fbd073f37508a1aeaafd3c6c3209fa0.svg";
export { ForwardRef as ReactComponent };